import Swal from 'sweetalert2';
import useForm from "../hooks/useForm";
import { useTranslation } from "react-i18next";

const FormMail = () => {

    const { t } = useTranslation('lang');

    const { handleFormChange, handleResetForm, inputValues } = useForm({ name: '', email: '', message: '', website: '' });
    const { name, email, message, website } = inputValues;

    const handleSubmit = (e) => {
        e.preventDefault();

        // Honeypot: si este campo viene completo es un bot, lo ignoramos en silencio
        if (website.trim().length) {
            handleResetForm();
            return;
        }

        if (!(name.trim().length) || !(email.trim().length) || !(message.trim().length)) {
            return Swal.fire({
                title: 'Form incomplete',
                text: t('form_incomplete'),
                icon: 'error',
                confirmButtonText: 'Cool'
            })
        }
        const formData = new FormData();
        formData.append('name', name);
        formData.append('email', email);
        formData.append('message', message);
        fetch(window.origin + '/envio.php', {
            method: 'POST',
            body: formData
        })
        .then( resp => {
            Swal.fire({
                title: 'Email sended',
                text: t('email_sended'),
                confirmButtonText: 'Cool'
            })
        })
        .catch(err => {
            Swal.fire({
                title: 'Error',
                text: 'Error',
                confirmButtonText: 'Cool'
            })
            console.log(err)
        })
        handleResetForm();
    }

    return (
        <form action="" className="form-mail" autoComplete="off" onSubmit={handleSubmit}>

            <div>
                <label htmlFor="name">{t('name_form')}</label>
                <strong>*</strong>
            </div>
            <input
                type="text"
                onChange={handleFormChange}
                value={name}
                id="name"
                name="name"
            />

            <div>
                <label htmlFor="email">{t('email_form')}</label>
                <strong>*</strong>
            </div>
            <input
                type="email"
                onChange={handleFormChange}
                value={email}
                id="email"
                name="email"
            />

            <div>
                <label htmlFor="message">{t('message_form')}</label>
                <strong>*</strong>
            </div>
            <input
                type="text"
                onChange={handleFormChange}
                value={message}
                id="message"
                name="message"
            />

            {/* Honeypot anti-spam: oculto para usuarios, los bots tienden a completarlo */}
            <input
                type="text"
                onChange={handleFormChange}
                value={website}
                id="website"
                name="website"
                tabIndex="-1"
                autoComplete="off"
                aria-hidden="true"
                style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
            />

            <button type="submit">{t('send_form')}</button>

        </form>
    )
}

export default FormMail;
